export const MAX_VISIBLE_PAYLOAD_ITEMS = 4

type PayloadImageLightboxItem = {
    kind?: string | null
    url?: string | null
    inputUrl?: string | null
}

export function buildPayloadImageLightbox(
    items: Array<PayloadImageLightboxItem | null | undefined>,
    clickedItem: PayloadImageLightboxItem,
) {
    const imageItems = items
        .filter((item): item is PayloadImageLightboxItem => Boolean(item))
        .slice(0, MAX_VISIBLE_PAYLOAD_ITEMS)
        .filter(item => item.kind === 'image' && Boolean(item.url))

    const clickedIndex = imageItems.indexOf(clickedItem)

    return {
        slides: imageItems.map(item => ({ src: item.inputUrl || item.url! })),
        index: clickedIndex >= 0 ? clickedIndex : 0,
    }
}

// Uploads such as iPhone HEIC photos keep their raw original, which browsers
// can't decode; only the converted size variants display. Lightboxes must fall
// back to the largest variant for these instead of showing a load error.
const UNDISPLAYABLE_IMAGE_TYPES = new Set(['image/heic', 'image/heif', 'image/tiff'])
const UNDISPLAYABLE_IMAGE_EXTENSION = /\.(heic|heif|tiff?)$/i

export function isBrowserDisplayableImage({
    contentType,
    filename,
}: {
    contentType?: string | null
    filename?: string | null
}) {
    if (contentType && UNDISPLAYABLE_IMAGE_TYPES.has(contentType.toLowerCase())) return false
    if (filename && UNDISPLAYABLE_IMAGE_EXTENSION.test(filename)) return false
    return true
}
